import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createTask, deleteTask, getAllTasks, updateTask } from './api';
import { useParams } from 'react-router-dom';

//CREATE hook (post new task to api)
export function useCreateTask() {
  const queryClient = useQueryClient();
  const { projectId } = useParams();

  return useMutation({
    mutationFn: (task) => {
      return createTask({
        task: task.values,
        projectId,
        accessToken: task.accessToken,
      });
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: ['tasks', projectId] }),
  });
}

export function useGetTasks({ accessToken }) {
  const { projectId } = useParams();
  // console.log('token from tasks ', accessToken);
  return useQuery({
    queryKey: ['tasks', projectId],
    queryFn: () => getAllTasks({ projectId, accessToken }),
    enabled: accessToken !== null,
    // enabled: projectId ? true : false,
    // staleTime: 500,
    // cacheTime: 60000,
    keepPreviousData: true, // Keep the previous data while refetching
  });
}

export function useUpdateTask() {
  const queryClient = useQueryClient();
  // const { projectId } = useParams()
  return useMutation({
    mutationFn: (task) =>
      updateTask({ task: task.values, accessToken: task.accessToken }),
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['tasks'] }),
  });
}

//DELETE hook (delete task in api)
export function useDeleteTask() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteTask,
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['tasks'] }),
  });
}
